import { createHttpEndpoint } from '../utils'

import type { ArticleVotes } from './models/article-votes'
import type { BasePageContent } from './models/base-page-content'
import type { HomeNavigationContent } from './models/home-navigation-page-content'

import type { ArticlePageContent } from '.'

/**
 * Retrieve content for a given pageName and pageType
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/content-service-web-api/definition}
 */
export const getPageContent = createHttpEndpoint<BasePageContent>({
  method: 'GET',
  operationId: 'fetchContentFromContentService',
  path: '/bm/content/:pageType/:pageName',
})

/**
 * Retrieve content for a given pageName, pageCategory and pageType
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/content-service-web-api/definition}
 */
export const getPageCategoryContent = createHttpEndpoint<BasePageContent>({
  method: 'GET',
  operationId: 'fetchCategoryContentFromContentService',
  path: '/bm/content/:pageType/:pageName/:pageCategory',
})

export const getHomeNavigationContent =
  createHttpEndpoint<HomeNavigationContent>({
    method: 'GET',
    operationId: 'fetchHomeNavigationContent',
    path: '/bm/navigation/home',
  })

/**
 * SEO Articles related
 */
export const getArticleVotes = createHttpEndpoint<ArticleVotes>({
  method: 'GET',
  operationId: 'fetchArticlesVotes',
  path: '/bm/branding/articles/:articleSlug/votes',
  transformResponseToCamelCase: true,
})

export const voteForArticle = createHttpEndpoint<ArticleVotes>({
  method: 'POST',
  operationId: 'voteForArticle',
  path: '/bm/branding/articles/:articleSlug/votes',
})

export const getArticleContent = createHttpEndpoint<ArticlePageContent>({
  method: 'GET',
  operationId: 'getArticleContent',
  path: '/bm/content/:pageType/:pageName',
})
